export const stripText = (text?: string) => {
  if (!text) return '';
  return text.replace(/<\/?[^>]+(>|$)/g, '');
};

export const replaceHostName = (url: string) =>
  url
    .replace('{host}', runtimeConfig.idaHost || '')
    .replace('{host_SOA}', runtimeConfig.idaHostSoa || '');
